import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { AccessRole, CustomTitle, FormCreatorService, IFormOptions, LoadingPanelService, LocalService, VisorComponent } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IGetTramSeguimientos } from '../../../../../../shared/interfaces/database/tramite';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { ActividadFormularioComponent } from '../../../actividad/actividad-formulario.component';
import { TableModule } from "primeng/table";

@Component({
  selector: 'app-seguimiento-documentos',
  standalone: true,
  imports: [CommonModule, ButtonModule, SkeletonModule, VisorComponent, ActividadFormularioComponent, TableModule,
    CustomTitle, TranslateModule
  ],
  templateUrl: './seguimiento-documentos.component.html'
})
export class SeguimientoDocumentosComponent implements OnInit, AfterViewInit {
  @Input() tramSeguimiento!: IGetTramSeguimientos;
  readonly options: IFormOptions= {
      enableSubmit: false,
      isDesigner: false,
      viewAnswerMode: true
  };
  
  trans: any = {};
  role = AccessRole;
  @ViewChild(VisorComponent) visorDialog !: VisorComponent;
  @ViewChild(ActividadFormularioComponent) actividadFormulario !: ActividadFormularioComponent;

  get hasFormularioRespuesta(): boolean {
    return !!this.tramSeguimiento.formularioRespuesta;
  }

  constructor(private readonly _t: TranslateService, public ls: LocalService) { 
  }

  ngOnInit(): void {
    this.translate();    
  }

  ngAfterViewInit(): void {
    if(this.hasFormularioRespuesta){
      this.actividadFormulario.radicado = this.tramSeguimiento.radicado;
      this.actividadFormulario.loadForm(this.tramSeguimiento.formularioId, this.tramSeguimiento.formularioVersion, this.tramSeguimiento.formularioRespuesta);
    }
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      documentos: this._t.get('common.documentos'),
    }));
  }

}
